export const es = {
  nav: {
    problem: "El problema",
    daily: "Posicionamiento",
    method: "Visión",
    wins: "Microvictorias",
    blog: "Blog",
    langSwitch: "Cambiar idioma",
  },
  hero: {
    eyebrow: "Punto de partida · Honestos · Sin diagnósticos",
    headline1: "¿Quieres perder peso",
    headline2: "pero no sabes por dónde empezar?",
    subhead:
      "AI Metabolic te ayuda a entender dónde estás, qué te bloquea y cuál podría ser tu siguiente paso.",
    ctaNote: "Déjanos tu correo y te enviaremos un test inicial. Sin diagnósticos, sin presión y sin compromiso.",
    promises: [
      { k: "¿Dónde estás ahora?", v: "Nos cuentas qué te está costando antes de empezar." },
      { k: "¿Qué te bloquea?", v: "Dolor, vergüenza, fatiga, intentos previos o falta de dirección." },
      { k: "¿Y después?", v: "Te enviaremos un test inicial y seguiremos aprendiendo contigo. Sin presión ni compromiso." },
    ],
    imageCaption: "Punto de partida · Calma · Sin juicios",
    quote: "\"Por primera vez\nalguien me pregunta dónde estoy\nantes de decirme dónde tengo que ir.\"",
    quoteAuthor: "Persona piloto · 52 años",
  },
  problem: {
    eyebrow: "01 / Lo que nadie te ha dicho",
    h2a: "No es tu voluntad.",
    h2b: "Nunca te han dado un método adaptado a ti.",
    cards: [
      {
        title: "Siempre has escuchado el mismo consejo.",
        body:
          "Genérico. Repetido. Sin que nadie entendiera tu cuerpo, tu dolor, tu vida real. Y cada vez te has sentido más sola.",
      },
      {
        title: "Los espacios no estaban pensados para ti.",
        body: "Máquinas pensadas para otros cuerpos. Programas que empiezan donde tú aún no puedes. Miradas.",
      },
      {
        title: "Cada intento te ha pesado más.",
        body: "Has vuelto con dolor, frustración y menos ganas. La motivación se gasta. La vergüenza se acumula.",
      },
      {
        title: "Y siempre vuelves al punto de partida.",
        body: "Planes genéricos. Ningún acompañamiento real. La sensación de que nada está hecho para ti — porque, de hecho, no lo estaba.",
      },
    ],
  },
  insight: {
    eyebrow: "02 / Qué cambiamos",
    line1: "No prometemos pérdida de peso.",
    line2a: "Ayudamos a personas que quieren perder peso a entender su",
    capacity: "punto de partida",
    autonomy: "y qué les puede estar bloqueando",
    confidence: "para tomar una mejor decisión",
    line2b: ".",
    stats: [
      "Empezamos donde tú estás hoy. No donde deberías estar.",
      "AI METABOLIC acompaña a la persona antes del primer gran paso.",
      "Sin juicios. Sin prisa. Sin vergüenza.",
    ],
  },
  dailyAI: {
    eyebrow: "03 / Cada día, a tu lado",
    h2a: "IA personalizada.",
    h2b: "Acompañamiento real.",
    intro:
      "AI METABOLIC es una IA entrenada para acompañar a personas que vuelven a aprender a moverse. Adapta la ruta a lo que puedes hacer hoy — no a lo que deberías — y aprende contigo, día a día. Ningún consejo genérico. Ninguna solución de estantería. Una activación que respira con tu situación real.",
    chip: "IA + personas · a tu ritmo",
    features: [
      {
        label: "Activación adaptada a tu cuerpo de hoy",
        body:
          "Lo que te proponemos cada día se calcula con tu talla, tu dolor, tu energía y tu historial. Si hoy puedes poco, hacemos poco. Si puedes más, subimos el listón — nunca antes del momento.",
      },
      {
        label: "Una IA que aprende tu situación",
        body:
          "No recibes consejos genéricos ni retos copiados. La IA lee qué te ha funcionado, qué has abandonado y por qué, y ajusta la ruta para que la próxima semana te toque exactamente lo que necesitas.",
      },
      {
        label: "Alguien que nunca te deja solo",
        body:
          "Te escribimos brevemente cada día. Te preguntamos cómo estás. Si no apareces, reescribimos la ruta — no te enviamos a comprobar disciplina. La constancia la sostenemos nosotros, no tu voluntad.",
      },
    ],
  },
  building: {
    eyebrow: "04 / Visión futura",
    h2a: "La dirección que queremos",
    h2b: "construir.",
    subtitle: "Ahora mismo no ofrecemos un programa cerrado. Estamos aprendiendo qué bloquea a las personas antes de empezar.",
    intro:
      "Con ese aprendizaje, queremos construir rutas seguras junto a profesionales: recuperar confianza, moverse sin miedo, ganar fuerza, mejorar funcionalidad y llegar mejor preparado al siguiente paso.",
    phases: [
      { label: "Reconexión" },
      { label: "Fuerza" },
      { label: "Funcionalidad" },
      { label: "Capacidad cardiorrespiratoria" },
      { label: "Autonomía" },
    ],
    footnote: "Esta es la dirección que queremos construir más adelante, con profesionales y a partir del aprendizaje real de las personas que se apunten.",
  },
  wins: {
    eyebrow: "05 / Microvictorias reales",
    h2a: "No kilos.",
    h2b: "Capacidad recuperada.",
    intro:
      "No te prometemos perder 20 kg en 3 meses. Te prometemos lo contrario de lo que has vivido: notar — de verdad — que tu cuerpo vuelve a responder. Pequeñas victorias que sí cambian tu vida.",
    list: [
      { title: "Levantarte de una silla con menos esfuerzo.", when: "primeras semanas" },
      { title: "Caminar 5 minutos más sin ahogarte.", when: "primeras semanas" },
      { title: "Subir un tramo de escaleras con menos fatiga.", when: "siguientes semanas" },
      { title: "Notar menos dolor articular en el día a día.", when: "siguientes semanas" },
      { title: "Dormir más profundamente y despertarte con más energía.", when: "primer mes" },
      { title: "Volver a confiar en tu cuerpo. Y en el proceso.", when: "el camino" },
    ],
    quote: "\"Salir un poco mejor de lo que has entrado.\"",
    quoteFooter: "Ese es el único objetivo de cada sesión. El resto llega solo.",
  },
  finalCta: {
    eyebrow: "05 / Recibir el test inicial",
    title: "¿Quieres entender mejor",
    titleEmph: "tu punto de partida?",
    subtitle: "Déjanos tu correo y te enviaremos un test inicial para entender mejor qué te puede estar bloqueando antes de empezar.",
    smallnote: "No es un diagnóstico médico ni una recomendación clínica. Estamos construyendo esta herramienta con criterio y prudencia.",
    button: "Recibir el test inicial",
    microcopy: "Te enviaremos el test por correo. Sin spam, sin presión y sin compromiso.",
    disclaimer: "AI Metabolic no sustituye una valoración médica ni ofrece diagnóstico. Ahora mismo estamos en fase de validación y aprendizaje para construir una herramienta de orientación más útil y segura.",
  },
  form: {
    success: {
      whatsappBtn: "Continuar por WhatsApp",
    },
    hero: {
      emailPlaceholder: "tu@correo.com",
    },
    full: {
      emailLabel: "Correo electrónico",
      emailRequired: "*",
      emailPlaceholder: "tu@correo.com",
      whatsappLabel: "WhatsApp",
      whatsappOptional: "(opcional · más personalizado)",
      whatsappPlaceholder: "+34 600 000 000",
      pharmacyLabel: "Código de farmacia",
      pharmacyOptional: "(opcional)",
      pharmacyPlaceholder: "ej. BCN-042",
      referrerLabel: "¿Cómo nos has conocido?",
      referrerSelect: "Selecciona…",
      referrerOptions: {
        farmacia: "En la farmacia",
        xarxes: "Redes sociales",
        amic: "Alguien me lo recomendó",
        cerca: "Google / búsqueda",
        altre: "Otro",
      },
      formNote: "Cero spam. Cero presión. Solo te contactamos con información útil.",
      submitFallback: "Enviando…",
      almostThere: "Casi estamos",
      finalHeading1: "Déjanos el correo y te preparamos",
      finalHeading2: "un primer paso adaptado a ti.",
    },
    screening: {
      stepLabel: "Paso",
      stepOf: "de",
      back: "Volver",
      walking: {
        eyebrow: "Para entender tu punto de partida",
        question: "¿Te cuesta caminar 10 minutos seguidos?",
        subtitle: "No hay respuesta correcta. Solo nos ayuda a saber dónde estás hoy.",
      },
      chair: {
        eyebrow: "Una más",
        question: "¿Te cuesta levantarte de una silla sin apoyarte?",
        subtitle: "Esta es la mejor pista de tu fuerza funcional.",
      },
      difficulty: {
        eyebrow: "Última pregunta",
        question: "¿Cuál es tu principal dificultad hoy?",
        subtitle: "Elige la que sientas más cercana. Siempre podrás cambiarlo hablando con nosotros.",
      },
      screeningOptions: {
        yes: "Sí, me cuesta",
        sometimes: "A veces",
        no: "No, lo hago sin problema",
      },
      difficultyOptions: {
        dolor: "El dolor / la fatiga",
        vergonya: "La vergüenza / las miradas",
        no_se_per_on: "No saber por dónde empezar",
        constancia: "Mantener la constancia",
        altres: "Otra cosa",
      },
    },
    errors: {
      invalidEmail: "Introduce un correo electrónico válido",
      generic: "No se ha podido completar. Inténtalo de nuevo.",
      success: "Recibido. Te contactamos pronto.",
      consentRequired: "Debes aceptar la política de privacidad para continuar.",
    },
    consent: {
      preLink: "He leído y acepto la",
      link: "política de privacidad",
      postLink: ".",
      detail: "Trataremos tus datos para contactarte y preparar tu acompañamiento. Puedes retirar el consentimiento cuando quieras.",
    },
  },
  footer: {
    description:
      "Un sistema de acompañamiento para personas con obesidad. Te ayudamos a recuperar capacidad, autonomía y confianza en tu cuerpo — paso a paso, sin juicios.",
    projectTitle: "Proyecto",
    contactTitle: "Contacto",
    contactCity: "Barcelona · ES",
    copyright: "Todos los derechos reservados.",
    medical: "No sustituye la atención médica profesional.",
    disclaimer: "AI METABOLIC no sustituye una valoración médica ni ofrece diagnóstico. Ahora mismo estamos en fase de validación y aprendizaje para construir una herramienta de orientación más segura y útil.",
    legalTitle: "Legal",
    legalNotice: "Aviso legal",
    privacyPolicy: "Política de privacidad",
    cookiePolicy: "Política de cookies",
  },
  cookieBanner: {
    ariaLabel: "Aviso de cookies",
    body: "Utilizamos cookies técnicas para recordar tu idioma y tus preferencias. No usamos cookies de seguimiento ni publicitarias.",
    policyLink: "Leer la política de cookies",
    acceptBtn: "Aceptar",
    essentialBtn: "Solo esenciales",
  },
  legal: {
    backHome: "Volver al inicio",
    lastUpdated: "Última actualización · junio 2026",
    notice: {
      title: "Aviso legal",
      s1: {
        title: "1. Identificación",
        body: "Este sitio web (ai-metabolic.com) está gestionado por una persona física en fase de validación del proyecto. La información de contacto del responsable se encuentra en la Política de Privacidad.",
      },
      s2: {
        title: "2. Datos de contacto",
        responsible: "Responsable: persona física en fase de validación",
        location: "Ubicación: Barcelona, España",
        contact: "Contacto: aimetabolichealth@gmail.com",
        note: "Los datos identificativos completos del responsable se facilitan a solicitud directa por correo electrónico, en cumplimiento del RGPD.",
      },
      s3: {
        title: "3. Objeto del sitio web",
        body: "AI METABOLIC es un proyecto de validación centrado en ofrecer acompañamiento personalizado a personas con obesidad y condiciones metabólicas. Actualmente recopilamos expresiones de interés (waitlist) para diseñar el servicio. No ofrecemos atención médica, no sustituimos a ningún profesional sanitario y no comercializamos ningún producto desde este sitio.",
      },
      s4: {
        title: "4. Condiciones de uso",
        body: "El usuario se compromete a hacer un uso correcto del sitio web, de conformidad con la ley y con este aviso legal. Queda prohibido cualquier uso que pueda dañar el funcionamiento del sitio o los derechos de terceros.",
      },
      s5: {
        title: "5. Propiedad intelectual",
        body: "Todos los contenidos del sitio (textos, imágenes, gráficos, código) son propiedad del responsable del proyecto o de terceros que han autorizado su uso. Queda prohibida su reproducción total o parcial sin autorización.",
      },
      s6: {
        title: "6. Ley aplicable",
        body: "Estas condiciones se rigen por la legislación española. Para cualquier controversia, las partes se someten a los juzgados y tribunales del domicilio del responsable, salvo que la ley imponga otro fuero.",
      },
    },
    privacy: {
      title: "Política de privacidad",
      s1: {
        title: "1. Introducción",
        body: "En AI METABOLIC nos tomamos muy en serio tu privacidad. Esta política explica qué datos recogemos, por qué, cómo los protegemos y qué derechos tienes, de acuerdo con el Reglamento General de Protección de Datos (RGPD - UE 2016/679) y la LOPDGDD (3/2018).",
      },
      s2: {
        title: "2. Responsable del tratamiento",
        responsible: "Responsable: Josep Mora Barberà",
        location: "Ubicación: Barcelona (España)",
        contact: "Contacto para temas de privacidad: aimetabolichealth@gmail.com",
      },
      s3: {
        title: "3. Qué datos recogemos",
        intro: "Cuando te apuntas a nuestra lista de espera, recogemos:",
        item1: "Datos de contacto: correo electrónico (obligatorio) y número de WhatsApp (opcional).",
        item2: "Datos del formulario de screening: respuestas a tres preguntas sobre tu capacidad funcional (caminar, levantarte) y sobre tu dificultad principal.",
        item3: "Datos técnicos y de procedencia: código de farmacia (opcional), cómo nos has conocido, parámetros UTM (fuente de la campaña), variante del CTA.",
        item4: "Marca temporal del consentimiento y del registro.",
        healthNote: "ATENCIÓN: Algunas respuestas del screening pueden constituir datos de salud (categoría especial según el art. 9 RGPD). Trataremos estos datos únicamente con tu consentimiento explícito y con medidas de seguridad reforzadas. Puedes optar por no responder el screening y dejar solo el correo.",
      },
      s4: {
        title: "4. Finalidad del tratamiento",
        purpose1: "Contactarte para ofrecerte información sobre el acompañamiento que estamos diseñando.",
        purpose2: "Personalizar el acompañamiento en función de tus respuestas (solo si has aceptado compartirlas).",
        purpose3: "Medir la efectividad de nuestras campañas de difusión (de forma agregada y anónima).",
      },
      s5: {
        title: "5. Base legal",
        body: "El tratamiento se basa en tu consentimiento explícito (art. 6.1.a y, para datos de salud, art. 9.2.a RGPD). Puedes retirar el consentimiento en cualquier momento escribiendo a aimetabolichealth@gmail.com sin que ello afecte a la licitud del tratamiento previo.",
      },
      s6: {
        title: "6. Proveedores y transferencias",
        body: "Para ofrecerte este servicio, contamos con proveedores externos que actúan como encargados del tratamiento:",
        provider1: "MongoDB Atlas (alojamiento de la base de datos) — servidores en la UE.",
        provider2: "Resend (servicio de envío de correos electrónicos) — servidores en EE.UU. con cláusulas contractuales tipo (SCC) de la UE.",
        provider3: "Emergent (plataforma de alojamiento del sitio web) — infraestructura conforme con el RGPD.",
        note: "Todas las transferencias internacionales se realizan con las garantías que establece el RGPD (cláusulas contractuales tipo o decisiones de adecuación).",
      },
      s7: {
        title: "7. Plazo de conservación",
        body: "Conservaremos tus datos mientras mantengas interés en el servicio o hasta que nos solicites su supresión. En cualquier caso, como máximo 24 meses desde el último contacto, transcurridos los cuales procederemos a su eliminación, salvo obligaciones legales que impongan su conservación.",
      },
      s8: {
        title: "8. Tus derechos",
        intro: "Puedes ejercer los siguientes derechos en cualquier momento:",
        right1: "Acceso: saber qué datos tuyos tenemos.",
        right2: "Rectificación: corregir datos inexactos.",
        right3: "Supresión (derecho al olvido): que borremos tus datos.",
        right4: "Limitación: restringir el tratamiento en ciertos supuestos.",
        right5: "Portabilidad: recibir tus datos en un formato estándar.",
        right6: "Oposición: oponerte al tratamiento por motivos personales.",
        howTo: "Para ejercer cualquiera de estos derechos, escríbenos a aimetabolichealth@gmail.com indicando el derecho que quieres ejercer y adjuntando una copia de tu DNI o documento equivalente. Responderemos en el plazo máximo de un mes.",
        complaint: "Si consideras que el tratamiento no se ajusta a la normativa, tienes derecho a presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es).",
      },
      s9: {
        title: "9. Seguridad",
        body: "Aplicamos medidas técnicas y organizativas adecuadas para proteger tus datos contra el acceso no autorizado, la pérdida o la alteración: cifrado en tránsito (HTTPS), control de acceso a la base de datos, copias de seguridad y revisiones periódicas.",
      },
      s10: {
        title: "10. Cambios en esta política",
        body: "Podemos actualizar esta política para adaptarla a cambios legales u operativos. La fecha de la última actualización se muestra en la parte superior. Te recomendamos revisarla periódicamente.",
      },
    },
    cookies: {
      title: "Política de cookies",
      s1: {
        title: "1. Qué son las cookies",
        body: "Las cookies son pequeños archivos de texto que se almacenan en tu navegador cuando visitas un sitio web. Permiten que el sitio recuerde tus preferencias y te reconozca entre visitas.",
      },
      s2: {
        title: "2. Qué tipo de cookies usamos",
        body: "AI METABOLIC solo utiliza cookies técnicas estrictamente necesarias para el funcionamiento del sitio. NO utilizamos cookies de terceros, de seguimiento publicitario, ni de análisis (como Google Analytics o Meta Pixel).",
        note: "Si en el futuro incorporamos cookies analíticas o de terceros, te pediremos tu consentimiento explícito antes de activarlas.",
      },
      s3: {
        title: "3. Cookies utilizadas",
        col1: "Nombre",
        col2: "Finalidad",
        col3: "Duración",
        row1Desc: "Recuerda el idioma seleccionado (catalán/castellano) entre visitas.",
        row2Desc: "Recuerda tu decisión sobre este aviso de cookies.",
        persistent: "Persistente (hasta borrar)",
        note: "Técnicamente, usamos localStorage, no cookies HTTP convencionales. La normativa europea aplica las mismas obligaciones a ambos sistemas.",
      },
      s4: {
        title: "4. Cómo gestionarlas",
        body: "Puedes borrar los datos almacenados del sitio en cualquier momento desde la configuración de tu navegador (apartado 'Privacidad' o 'Datos del sitio'). Al borrarlos, perderás la preferencia de idioma y volveremos a mostrarte el banner de cookies.",
      },
      s5: {
        title: "5. Más información",
        body: "Para más detalles sobre cómo tratamos tus datos, consulta nuestra Política de Privacidad.",
      },
    },
  },
  ctaVariants: {
    info: {
      eyebrowFinal: "Entender mi punto de partida",
      heroButton: "Quiero entender mi punto de partida",
      navButton: "Entender el punto de partida",
      finalButton: "Responder las preguntas",
      finalH2Pre: "Responde unas preguntas breves.",
      finalH2Mid: "No es un diagnóstico médico ni una recomendación clínica.",
      finalH2Post: "Nos ayuda a entender qué te puede estar bloqueando y a construir una orientación más útil y segura.",
      finalDescription:
        "Estamos en fase de validación y aprendizaje. Queremos entender qué bloquea a personas como tú antes de proponer nada. Te contactaremos con lo que vayamos aprendiendo y, si quieres, podremos hablar para entender mejor tu caso.",
      successTitle: "Te hemos recibido",
      successBody:
        "Gracias. Pronto te haremos llegar un test inicial para ayudarte a entender mejor tu punto de partida. Sin prisa, sin compromisos y sin juicios.",
    },
    plan: {
      eyebrowFinal: "Mi primer paso",
      heroButton: "Quiero mi primer paso",
      navButton: "Mi primer paso",
      finalButton: "Crear mi primer paso",
      finalH2Pre: "Empecemos por tu",
      finalH2Mid: "primer paso —",
      finalH2Post: "lo que tu cuerpo puede hoy.",
      finalDescription:
        "Déjanos el correo y, en menos de 24h, te explicamos cómo sería tu primer paso adaptado a ti. Sin cambiar toda tu vida de un día para otro.",
      successTitle: "Tenemos tus datos",
      successBody:
        "En menos de 24h recibirás en el correo tu primer paso, pensado para ti. Te escribiremos por WhatsApp para acabar de ajustarlo contigo — sin presión.",
    },
    reserva: {
      eyebrowFinal: "Reserva tu lugar",
      heroButton: "Reservar mi lugar",
      navButton: "Reserva el lugar",
      finalButton: "Reservar mi lugar",
      finalH2Pre: "Reserva tu lugar",
      finalH2Mid: "en la primera cohorte.",
      finalH2Post: "Acompañamiento limitado.",
      finalDescription:
        "La primera cohorte es pequeña porque queremos acompañar bien a cada persona. Déjanos el correo y te guardamos el lugar mientras lo revisamos contigo — sin compromiso de pago.",
      successTitle: "Lugar reservado",
      successBody:
        "Tienes el lugar reservado provisionalmente. Te escribiremos en menos de 24h para confirmarlo y explicarte los siguientes pasos — por correo y, si quieres, por WhatsApp.",
    },
    whatsapp: {
      eyebrowFinal: "Hablemos un momento",
      heroButton: "Hablemos un momento",
      navButton: "Hablemos",
      finalButton: "Empezar la conversación",
      finalH2Pre: "Hablemos un momento.",
      finalH2Mid: "Sin formularios largos.",
      finalH2Post: "Una persona real, no un bot.",
      finalDescription:
        "Déjanos el correo y el WhatsApp. Una persona de nuestro equipo te escribirá en menos de 24h para entender tu situación — a tu ritmo, sin presión.",
      successTitle: "Te escribimos pronto",
      successBody:
        "Una persona de nuestro equipo te escribirá en menos de 24h. Si quieres acelerar la conversación, puedes empezar tú mismo en WhatsApp clicando el botón de abajo.",
    },
  },
};
